import React, { forwardRef, useId } from 'react';
import { ChevronDown } from 'lucide-react';

/** Shared look for compact filter-bar text/date inputs sitting alongside a Select. Add your own width class. */
export const filterInputClassName =
  'rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 ' +
  'placeholder:font-normal placeholder:text-slate-400 transition hover:border-slate-300 ' +
  'focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-500/15';

/**
 * Reusable filter/form dropdown — replaces the browser's default <select> look
 * with a chevron icon and the same border/focus-ring language as TextField.
 */
export const Select = forwardRef(function Select(
  { label, id, className = '', containerClassName = '', children, ...props },
  ref
) {
  const generatedId = useId();
  const selectId = id || generatedId;

  return (
    <div className={`flex flex-col gap-1.5 ${containerClassName}`}>
      {label && (
        <label
          htmlFor={selectId}
          className="text-xs font-bold uppercase tracking-wide text-slate-600"
        >
          {label}
        </label>
      )}
      <div className="relative">
        <select
          ref={ref}
          id={selectId}
          className={[
            'w-full appearance-none rounded-lg border border-slate-200 bg-white py-2 pl-3 pr-9',
            'text-sm font-medium text-slate-700 transition',
            'hover:border-slate-300 focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-500/15',
            'disabled:cursor-not-allowed disabled:opacity-60',
            className,
          ].join(' ')}
          {...props}
        >
          {children}
        </select>
        <ChevronDown
          size={14}
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
        />
      </div>
    </div>
  );
});

export default Select;
